import uploadVideoToS3 from '../common/utils/uploadVideoToS3';
import client from '../client';
import forEach from 'lodash/forEach';
import uuid from 'uuid';

export const ADD_SECTION = 'ADD_SECTION';
export const ADD_CATEGORY = 'ADD_CATEGORY';
export const DELETE_CATEGORY = 'DELETE_CATEGORY';
export const CLEAR_COURSE_LESSONS = 'CLEAR_COURSE_LESSONS';
export const CREATE_LIBRARY_RECORD = 'CREATE_LIBRARY_RECORD';
export const DELETE_SECTION = 'DELETE_SECTION';
export const EDIT_CATEGORY = 'EDIT_CATEGORY';
export const FETCH_CATEGORIES = 'FETCH_CATEGORIES';
export const FETCH_COURSE_LESSONS = 'FETCH_COURSE_LESSONS';
export const FETCH_SECTION = 'FETCH_SECTION';
export const GET_LIBRARY_RECORD = 'GET_LIBRARY_RECORD';
export const REORDER_SECTIONS = 'REORDER_SECTIONS';
export const REORDER_CATEGORIES = 'REORDER_CATEGORIES';
export const REORDER_LIBRARY_VIDEOS = 'REORDER_LIBRARY_VIDEOS';
export const SET_CATEGORY_ACTIVITY = 'SET_CATEGORY_ACTIVITY';
export const SET_CATEGORY_NAME = 'SET_CATEGORY_NAME';
export const SET_CATEGORY_COURSE = 'SET_CATEGORY_COURSE';
export const UPDATE_CATEGORY_THUMBNAIL = 'UPDATE_CATEGORY_THUMBNAIL';
export const UPDATE_LIBRARY_RECORD = 'UPDATE_LIBRARY_RECORD';
export const UPDATE_SECTION = 'UPDATE_SECTION';
export const UPLOAD_LIBRARY_VIDEO = 'UPLOAD_LIBRARY_VIDEO';
export const UPLOAD_LIBRARY_VIDEO_PROGRESS = 'UPLOAD_LIBRARY_VIDEO_PROGRESS';

export function fetchCourseLessons(courseId) {
  return {
    type: FETCH_COURSE_LESSONS,
    promise: client.get(`courses/${courseId}/lessons/all`),
  };
}
export function clearCourseLessons() {
  return {
    type: CLEAR_COURSE_LESSONS,
  };
}

export function fetchCategories() {
  return {
    type: FETCH_CATEGORIES,
    promise: client.get(`library/categories`),
  };
}

export function fetchSection(categoryId, sectionId) {
  return {
    type: FETCH_SECTION,
    promise: client.get(`library/categories/${categoryId}/sections/${sectionId}`),
  };
}

export function addSection(categoryId, name) {
  return {
    type: ADD_SECTION,
    promise: client.post(`library/categories/${categoryId}/sections`, { name }),
  };
}

export function addCategory(name) {
  return {
    type: ADD_CATEGORY,
    promise: client.post(`library/categories`, { name }),
  };
}

export function deleteCategory(categoryId) {
  return {
    type: DELETE_CATEGORY,
    promise: client.delete(`library/categories/${categoryId}`,
  ),
  }
}

export function updateSectionName(categoryId, sectionId, payload) {
  return {
    type: UPDATE_SECTION,
    promise: client.patch(`library/categories/${categoryId}/sections/${sectionId}`, payload),
  };
}

export function deleteSection(categoryId, sectionId) {
  return {
    type: DELETE_SECTION,
    promise: client.delete(`library/categories/${categoryId}/sections/${sectionId}`),
    categoryId,
    sectionId,
  };
}

export function setCategoryActivity(categoryId, active) {
  return {
    type: SET_CATEGORY_ACTIVITY,
    promise: client.patch(`library/categories/${categoryId}`, { active }),
  };
}

export function setCategoryName(categoryId, name) {
  return {
    type: SET_CATEGORY_NAME,
    promise: client.patch(`library/categories/${categoryId}`, { name })
  }
}

export function setCategoryCourse(categoryId, is_course) {
  return {
    type: SET_CATEGORY_COURSE,
    promise: client.patch(`library/categories/${categoryId}`, { is_course })
  }
}

export function updateCategoryThumbnail(categoryId, values) {
  const data = new FormData();
  data.append('image', values.image, uuid.v4());

  return {
    type: UPDATE_CATEGORY_THUMBNAIL,
    promise: client.patch(`library/categories/${categoryId}/thumbnail`, data),
  };
}

export function createLibraryRecord(categoryId, sectionId, payload) {
  return {
    type: CREATE_LIBRARY_RECORD,
    promise: client.post(`library/categories/${categoryId}/sections/${sectionId}/videos`, payload),
  };
}

export function updateUploading(uploading) {
  return {
    type: UPLOAD_LIBRARY_VIDEO,
    uploading,
  };
}

export function updateUploadProgress(loaded, total) {
  return {
    type: UPLOAD_LIBRARY_VIDEO_PROGRESS,
    loaded,
    total,
  };
}

export function getLibraryRecord(categoryId, sectionId, videoId) {
  return {
    videoId,
    type: GET_LIBRARY_RECORD,
    promise: client.get(`library/categories/${categoryId}/sections/${sectionId}/videos/${videoId}`, null, {
      credentials: 'include', // Required for browser to respect Set-Cookie headers
    }),
  };
}

export function uploadVideo(categoryId, sectionId, libraryRecordId, file) {
  return dispatch => {
    dispatch(updateUploading(true));

    return uploadVideoToS3(dispatch, file, updateUploadProgress)
      .then(data => dispatch(updateLibraryRecord(categoryId, sectionId, libraryRecordId, { videoId: data.Key })))
      .then(() => dispatch(getLibraryRecord(categoryId, sectionId, libraryRecordId)))
      .then(() => {
        dispatch(updateUploading(false));
        dispatch(updateUploadProgress(0, 100));
      });
  };
}

export function updateLibraryRecord(categoryId, sectionId, libraryRecordId, values) {
  const data = new FormData();

  forEach(values, (value, name) => {
    if (name === 'image') {
      data.append('image', value, uuid.v4());
    } else if (value !== undefined || typeof value !== 'undefined') {
      data.append(name, value);
    }
  });

  return {
    type: UPDATE_LIBRARY_RECORD,
    promise: client.patch(`library/categories/${categoryId}/sections/${sectionId}/videos/${libraryRecordId}`, data),
  };
}

export function editCategory(categoryId, values) {
  const data = new FormData();
  if (values.image_id) data.append('image_id', values.image_id);
  if (values.image) data.append('image', values.image, uuid.v4());

  return {
    type: EDIT_CATEGORY,
    promise: client.put(`library/categories/${categoryId}`, data),
  };
}

export function reorderSections(categoryId, values) {
  return {
    type: REORDER_SECTIONS,
    promise: client.patch('library/sections/sort-order', values),
    categoryId,
  };
}

export function reorderCategories(values) {
  return {
    type: REORDER_CATEGORIES,
    promise: client.patch('library/categories/sort-order', values),
  }
}

export function reorderLibraryVideos(categoryId, sectionId, values) {
  return {
    type: REORDER_LIBRARY_VIDEOS,
    promise: client.patch('library/videos/sort-order', values),
    categoryId,
    sectionId,
  };
}



// WEBPACK FOOTER //
// ./src/library/actions.js